<template>
    <div class="view view--add-startdesk-category">
        <edit-startdesk-category />
    </div>
</template>

<script>
    import editStartdeskCategory from '../../../components/EditStartdeskCategory.vue';

    export default {
        components: {
            editStartdeskCategory
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/startdesks/categories/Add.vue